<template>
  <div class="checkTel">
    <!--<div>-->
    <!--<input v-model="phone" :readonly="readonly" maxlength="11" type="tel" id="tel" placeholder="请输入手机号">-->
    <!--<p v-show="sendAuthCode" @click="acquire" >获取验证码</p>-->
    <!--<p class="dumiao" v-show="!sendAuthCode" >{{auth_time + '秒后重新获取'}}</p>-->
    <!--</div>-->
    <!--<input v-model="code" maxlength="6" type="tel" id="yzm" placeholder="请输入验证码">-->
    <!---->
    <p class="title">手机号绑定</p>
    <input v-model="phone" :readonly="readonly" maxlength="11" type="tel" class="tel" id="tel" placeholder="请输入手机号">
    <div>
      <input v-model="code" maxlength="6" type="tel" class="tel" id="tel1" placeholder="请输入验证码">
      <p :style="this.phone.length===0 ? 'opacity:.6' : 'opacity:1'" v-show="sendAuthCode" @click="acquire" >获取验证码</p>
      <p class="dumiao" v-show="!sendAuthCode" >{{auth_time + '秒后重新获取'}}</p>
    </div>
    <input @click="sub" :disabled="this.nump !== 1 || !this.code" type="button" class="commit" value="绑定">
  </div>
</template>
<script>
  export default {
    data () {
      return {
        sendAuthCode: true,
        phone: '',
        code: '',
        readonly:false,
        nump: 0,
        auth_time: 0
      }
    },
    mounted(){
      // 这个是正式的，暂时不是北大资源的项目。
      const _this = this
      console.log('2222')
      // _this.postRequest('cuser/login/phoneRegisted', {}, function (data) {
      //   if (data.phone) {
      //     _this.$router.push('/houseInfo')
      //   }else{
      //     console.log('暂无手机号')
      //   }
      // }).catch(res =>{
      //   console.log(res)
      // })

    },
    methods: {
      acquire () {
        const _this = this
        const reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
        if (_this.phone.length === '') {
          alert('请输入手机号')
        } else if (!reg.test(_this.phone)) {
          alert('请输入正确的手机号')
        } else {

          _this.readonly = true
          _this.sendAuthCode = false
          _this.auth_time = 60
          const auth_timetimer = setInterval(() => {
            this.auth_time--
            if (this.auth_time <= 0) {
              this.sendAuthCode = true
              clearInterval(auth_timetimer)
            }
          }, 1000)
          _this.nump = 1
          _this.postRequest('user/sendVerificationCode', {
            phone: _this.phone
          },function (data) {

          })
        }
      },
      sub () {
        const _this = this
        _this.postRequest('user/validatePhone', {
          phone: _this.phone,
          code: _this.code
        },function (data) {
          sessionStorage.setItem('phone', _this.phone)
          let url = sessionStorage.getItem('home')
          _this.$router.push({name: url})
        })
      }
    }
  }
</script>
<style scoped>
  input {-webkit-appearance:none; /*去除苹果手机的input默认样式*/}
  .checkTel{
    width: 100%;
    height: 100%;
    text-align: left;
    background-color: #fff;
    padding: 123px 85px 0 85px;
    box-sizing: border-box;
  }
  ::-webkit-input-placeholder{
    font-size: 28px;
    color:#999999;
  }
  .checkTel .title{
    font-size:44px;
    color:rgba(51,51,51,1);
    line-height:40px;
    font-weight: bold;
    letter-spacing:4px
  }
  .checkTel .tel{
    width:100%;
    height:140px;
    font-size:34px;
    color:#000;
    line-height:40px;
    margin-top: 38px;
    border-bottom: 2px solid #CCC;
  }
  .checkTel div{
    position: relative;
    top: 0;
    left: 0;
  }
  .checkTel div p{
    width:216px;
    height:62px;
    line-height: 62px;
    border-radius:28px;
    position: absolute;
    bottom: 46px;
    right: 0;
    font-size:26px;
    color:rgba(255,255,255,1);
    text-align: center;
    background: -webkit-linear-gradient(left, #FFA750 , #F7B832); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(right, #FFA750, #F7B832); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(right, #FFA750, #F7B832); /* Firefox 3.6 - 15 */
    background: linear-gradient(to right, #FFA750 , #F7B832); /* 标准的语法 */
  }
  .checkTel .commit:disabled{
    opacity: .6;
  }
  .checkTel .commit {
    width:580px;
    height:100px;
    border-radius:50px;
    color: #fff;
    font-size:32px;
    letter-spacing: 20px;
    margin-top: 146px;
    background: -webkit-linear-gradient(left, #FFA750 , #F7B832); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(right, #FFA750, #F7B832); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(right, #FFA750, #F7B832); /* Firefox 3.6 - 15 */
    background: linear-gradient(to right, #FFA750 , #F7B832); /* 标准的语法 */
  }
</style>



// WEBPACK FOOTER //
// src/components/beidaziyuan/checkTel-bdzy.vue